// Why the session ended: it expired, or a different user signed in from
// another tab, so this tab's session cookies now belong to someone else.
export type SessionEndReason = 'expired' | 'user_changed';

// Doesn't sign out: when another user signed in from a different tab, the
// session belongs to them. The session-expired page lets this tab choose to
// continue as them or sign out.
export const redirectToSessionExpired = (
  reason: SessionEndReason = 'expired',
) => {
  localStorage.setItem(import.meta.env.VITE_SESSION_EXPIRED, 'true');
  sessionStorage.clear();
  window.location.replace(
    reason === 'expired'
      ? '/session-expired'
      : `/session-expired?reason=${reason}`,
  );
};
